import React from "react";

import Header from "../components/header";
import DividerBottom from "../components/divider-bottom";
import Footer from "../components/footer";

import ScoutsLogo from "../assets/images/scouts_logo.png";
import ScoutsUniform from "../assets/images/scouts-uniform.png";
import ScoutsBadgePlacement from "../assets/images/scouts-badge-placement.png";

function Scouts() {
    return (
        <>
            <Header />

            <main id="scouts">
                <div className="sections-container">
                    <div className="section-item">
                        <img src={ScoutsLogo} alt="Scouts"></img>
                        <p>10½ - 14 Years</p>
                        <p>Term-time Tuesdays 7:45 - 9:15pm</p>
                    </div>
                </div>
                <section id="section-details">
                    <section id="about-section">
                        <h1>About Scouts</h1>
                        <ul>
                            <li>Scouts are our oldest members, aged between 10½ and 14 years old.</li> 
                            <li>They typically meet for an hour and a half per week.</li>
                            <li>Like the Cubs, they are introduced to more adventurous outdoor activities, but are given more trust and freedom to do things by themselves.</li>
                        </ul>
                    </section>
                    <section id="leaders-section">
                        <h1>Who runs the section?</h1>
                        <p>The Scout group at the 17th is run by a team of hardworking volunteers, who dedicate their time to making sure your children experience the best that Scouting has to offer.</p>
                        <ul>
                            <li>Section Leader: Hawkeye</li>
                            <li>Group Scout Leader / Assistant Section Leader: Leela</li>
                            <li>Assistant Section Leader: Robin</li>
                        </ul>
                    </section>
                    <section id="promise-section">
                        <h1>The Scout Promise and Law</h1>
                        <h2>The Scout Promise</h2>
                        <ul>
                            <li>On my honour, I promise that I will do my best</li>
                            <li>To do my duty to God and to the King</li>
                            <li>To help other people</li>
                            <li>And to keep the Scout Law</li>
                        </ul>
                        <br></br>
                        <h2>The Scout Law</h2>
                        <ul>
                            <li>A Scout is to be trusted.</li>
                            <li>A Scout is loyal.</li>
                            <li>A Scout is friendly and considerate.</li>
                            <li>A Scout belongs to the worldwide family of Scouts.</li>
                            <li>A Scout has courage in all difficulties.</li>
                            <li>A Scout makes good use of time and is careful of possessions and property.</li>
                            <li>A Scout has self-respect and respect for others.</li>
                        </ul>
                    </section> 
                </section>

                <section id="uniform-info">
                    <h1>Uniform and Badges</h1>
                    <div className="uniform-info-container">
                        <div className="uniform-info-item">
                            <h3>What Scouts wear</h3>
                            <p>Scouts wear a teal green shirt, our group t-shirt with a neckerchief and coloured woggle for their patrol. They pair this with navy blue activity trousers or shorts and may include a belt. We expect Scouts to wear sturdy footwear as they will be doing lots of adventurous activities.</p>
                        </div>
                        <div className="uniform-info-item">
                            <h3>Why uniform is important</h3>
                            <p>Wearing a uniform is comfy and practical and means you can run around and get messy without ruining your other clothes. It makes you feel part of a team and means no one feels uncomfortable or left out. It also gives you a place to show off all the brilliant badges you earn.</p>
                        </div>
                        <div className="uniform-info-item">
                            <h3>Where you can buy the uniform</h3>
                            <p>Uniform can either be bought from the online Scout Association shop - <a href="https://shop.scouts.org.uk/" target="_blank">Scout Store</a> - or from a local supplier such as the Butchers Coppice Scout shop or some school uniform shops. If you're stuck, ask us to tell you more about what to buy and where to buy it. If cost is an issue, we may have some second-hand kit available.</p>
                        </div>
                    </div>
                </section>
                
                <section id="uniform-images">
                    <div className="uniform-images-container">
                        <img src={ScoutsUniform} alt="Scout Uniform Diagram"></img>
                        <img src={ScoutsBadgePlacement} alt="Scouts Badge Placement Diagram"></img>
                    </div>
                </section>
                <DividerBottom />
            </main>
            <Footer />
        </>
    );
}

export default Scouts;